/**
 * Used as a label for a header whose `textContent` is `null` or `""`.
 * This shouldn't happen for most cases.
 */
export const HEADER_NO_TITLE = 'HEADER_NO_TITLE';
